import React from 'react';
import { Button } from './ui/button';
import { Sparkles, Cloud, ArrowRight, Calendar, Mail } from 'lucide-react';

const Community = () => {
  return (
    <section 
      className="py-10 md:py-14 relative overflow-hidden bg-gradient-to-br from-blue-50 via-cyan-50 to-teal-50"
      aria-labelledby="community-heading"
    >
      {/* Decorative clouds */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
        <div className="absolute top-1/4 left-10 w-24 h-12 md:w-32 md:h-16 bg-blue-100/50 rounded-full blur-2xl animate-cloud-drift" />
        <div className="absolute bottom-1/4 right-16 w-32 h-16 md:w-40 md:h-20 bg-cyan-100/50 rounded-full blur-2xl animate-float" />
        <div className="absolute top-1/3 right-1/4 w-20 h-10 bg-teal-100/40 rounded-full blur-xl animate-float" style={{ animationDelay: '1.5s' }} />
        <div className="absolute bottom-1/3 left-1/3 w-28 h-14 bg-blue-100/40 rounded-full blur-xl animate-cloud-drift-slow" />
      </div>
      
      <div className="container mx-auto px-4 text-center relative z-10">
        <div className="flex justify-center mb-3">
          <div className="relative p-2 bg-white/70 rounded-full shadow-sm" aria-hidden="true">
            <Cloud className="w-5 h-5 text-blue-500" />
            <Sparkles className="absolute -top-0.5 -right-0.5 w-2.5 h-2.5 text-cyan-400 animate-pulse" />
          </div>
        </div>
        
        <h2 id="community-heading" className="text-lg md:text-2xl lg:text-3xl font-bold text-stone-800 max-w-2xl mx-auto leading-relaxed mb-4">
          <span className="md:hidden">
            if you're a{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-500 via-cyan-500 to-teal-500">data dreamer</span>
            {' '}like me,
            <br />
            let's become our best selves together
          </span>
          <span className="hidden md:block whitespace-nowrap">
            if you're a{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-500 via-cyan-500 to-teal-500">data dreamer</span>
            {' '}like me,
          </span>
          <span className="hidden md:block whitespace-nowrap">
            let's become our best selves together
          </span>
        </h2>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3" role="group" aria-label="Community actions">
          {/* Get access to resources & 2026 events - links to datadreaming.cloud */}
          <a
            href="https://www.datadreaming.cloud"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Get access to resources and 2026 events - opens Data Dreaming website"
          >
            <Button
              size="lg"
              className="group bg-gradient-to-r from-blue-500 via-cyan-500 to-teal-500 hover:from-blue-600 hover:via-cyan-600 hover:to-teal-600 text-white px-4 py-3 text-[10px] md:text-xs rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-0.5 border-0 focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:ring-offset-2"
            >
              <Calendar className="mr-1.5 w-3 h-3" aria-hidden="true" />
              <span>get access to resources &amp; 2026 events</span>
              <ArrowRight className="ml-1.5 w-3 h-3 group-hover:translate-x-1 transition-transform" aria-hidden="true" />
            </Button>
          </a>
          
          {/* Sign up - links to beehiiv newsletter */}
          <a
            href="https://datadreaming.beehiiv.com/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Sign up for Data Dreaming newsletter"
          >
            <Button
              size="lg"
              variant="outline"
              className="group bg-white/80 hover:bg-white text-stone-700 hover:text-stone-900 px-4 py-3 text-[10px] md:text-xs rounded-full shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-0.5 border border-stone-200 focus:outline-none focus:ring-2 focus:ring-stone-400 focus:ring-offset-2"
            >
              <Mail className="mr-1.5 w-3 h-3" aria-hidden="true" />
              <span>sign up for data dreaming newsletter</span>
              <ArrowRight className="ml-1.5 w-3 h-3 group-hover:translate-x-1 transition-transform" aria-hidden="true" />
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Community;
